

export const tabA11yProps = index => ({
	"aria-controls": `tabpanel-${index}`,
	"id": `tab-${index}`
});

export const TabPanel = props => {
	const { children, value, index } = props;

	return (
		<div
			aria-labelledby={`tab-${index}`}
			hidden={index !== value}
			id={`tabpanel-${index}`}
			role="tabpanel"
		>
			{
				value === index && children
			}
		</div>
	);
};